import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import pricingPeriodUpdatedData from '@/store/modules/data/pricingPeriodUpdatedData';
import accessControl from './modules/accessControl';
import auth from './modules/auth';
import breadcrumbs from './modules/breadcrumbs';
import cacheModules from './modules/cache';
import contracts from './modules/data/contracts';
import devMode from './modules/devMode';
import preventQuitFormular from './modules/preventQuitFormular';
import features from './modules/data/features';
import loading from './modules/loading';
import dynamicRoutes from './modules/dynamicRoutes';


import lang from './modules/lang';
import tutorial from './modules/tutorial';
import graphics from './modules/graphics';
import nextAndPrevious from './modules/nextAndPrevious';
import steps from './modules/steps';

import analysisSample from './modules/data/analysisSample';
import accessGroup from './modules/data/accessGroup';
import analysisType from './modules/data/analysisType';
import assessment from './modules/data/assessment';
import chartControl from './modules/data/chartControl';
import client from './modules/data/client';
import component from './modules/data/component';
import componentType from './modules/data/componentType';
import contact from './modules/data/contact';
import woTemplate from './modules/data/woTemplate';
import inventoryActivity from './modules/data/inventoryActivity';
import labWorkOrder from './modules/data/labWorkOrder';
import lockFrom from './modules/data/lockFrom';
import member from './modules/data/member';
import navigation from './modules/data/navigation';
import network from './modules/data/network';
import networkType from './modules/data/networkType';
import massBalanceStepData from './modules/data/massBalanceStepData';
import maintenanceData from './modules/data/maintenance';
import product from './modules/data/product';
import riskAnalysis from './modules/data/riskAnalysis';
import site from './modules/data/site';
import siteDocument from './modules/data/siteDocument';
import standardFamily from './modules/data/standardFamily';
import workOrder from './modules/data/workOrder';
import orders from './modules/data/order';
import alertsNotifications from './modules/data/alertsNotifications';
import copySite from './modules/data/copySIte';
import team from './modules/data/team';
import e4Config from './modules/data/e4Config';

const vuexPersist = new VuexPersistence({
    strictMode: true,
    key: 'aquassist',
    storage: window.localStorage,
    modules: ['auth', 'accessControl', 'tutorial', 'contracts', 'team'],
});

Vue.use(Vuex);

const modules = {
    analysisSample,
    accessControl,
    accessGroup,
    analysisType,
    assessment,
    auth,
    breadcrumbs,
    nextAndPrevious,
    chartControl,
    client,
    component,
    componentType,
    contact,
    contracts,
    devMode,
    dynamicRoutes,
    features,
    inventoryActivity,
    labWorkOrder,
    lockFrom,
    lang,
    loading,
    tutorial,
    steps,
    graphics,
    member,
    navigation,
    network,
    networkType,
    massBalanceStepData,
    maintenanceData,
    preventQuitFormular,
    pricingPeriodUpdatedData,
    product,
    riskAnalysis,
    site,
    siteDocument,
    standardFamily,
    workOrder,
    woTemplate,
    orders,
    alertsNotifications,
    copySite,
    team,
    e4Config,
    ...cacheModules,
};

const store = new Vuex.Store({
    strict: true,
    modules,
    mutations: {
        RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION, // this mutation **MUST** be named "RESTORE_MUTATION"
    },
    plugins: [vuexPersist.plugin],
});

export default store;
